import { lazy, Suspense } from 'react';
import type { Navigation } from '@/app/contract';
import type { CommunityReportTarget } from './sheets/types';
const Composer = lazy(() => import('./composer/PostComposer'));
const Report = lazy(() => import('./sheets/ReportSheet'));
const Share = lazy(() => import('./sheets/ShareSheet'));
const Folders = lazy(() => import('./sheets/FolderPicker'));
export function compose(nav: Navigation, options: { postId?: string; localId?: string; topicId?: string } = {}) {
  const handle: { dismiss(): void } = nav.present(<Suspense fallback={null}><Composer {...options} close={() => handle.dismiss()} /></Suspense>, { size: nav.layout === 'phone' ? 'large' : 'medium' });
}
export function report(nav: Navigation, subject: CommunityReportTarget) {
  const handle: { dismiss(): void } = nav.present(<Suspense fallback={null}><Report subject={subject} close={() => handle.dismiss()} /></Suspense>, { size: nav.layout === 'phone' ? 'medium' : 'small' });
}
export function share(nav: Navigation, postId: string) {
  const handle: { dismiss(): void } = nav.present(<Suspense fallback={null}><Share postId={postId} close={() => handle.dismiss()} /></Suspense>, { size: nav.layout === 'phone' ? 'medium' : 'small' });
}
export function folders(nav: Navigation, postId: string) {
  const handle: { dismiss(): void } = nav.present(<Suspense fallback={null}><Folders postId={postId} close={() => handle.dismiss()} /></Suspense>, { size: nav.layout === 'phone' ? 'medium' : 'small' });
}
